











import Vue from "vue";

export default Vue.extend({
  name: "AuthContainer",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
});
